import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@src/common/formatImage';

class Support extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;

        return (
            <div>
                {
                    content.map((item, index) => {
                        return (
                            <div className={styles.support} key={index}>
                                <div className={styles.title}>{item.title}</div>
                                {
                                    item.imageList.map((image, idx) => {
                                        return (
                                            <div className={styles.image} key={`${index}_${idx}`}>
                                                <a href={image.url} target="_blank" rel="noreferrer">
                                                    <img src={formatImage(image.image, 290, 80)} alt="" />
                                                </a>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default Support;
